import { render, staticRenderFns } from "./ProfissionalModal.vue?vue&type=template&id=20930fcb&scoped=true"
import script from "./ProfissionalModal.vue?vue&type=script&lang=js"
export * from "./ProfissionalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20930fcb",
  null
  
)

export default component.exports